module.exports = "/_next/static/images/dd7ef49fa5a4f3052c303f2501f92383-check.svg.webp";